import { BasicStandardOkDialogProperties } from "@goodgamestudios/core";
import { CommonDialogNames } from "@goodgamestudios/core";
import { TextFieldHelper } from "@goodgamestudios/core";
import { Poker2Dialog } from "./Poker2Dialog";

import Container = createjs.Container;
import MouseEvent = createjs.MouseEvent;

export class Poker2StandardOkDialog extends Poker2Dialog {
    public static NAME: string;

    constructor(disp: Container) {
        super(disp);
    }
    protected init(): void {
        super.init();
        console.log("Opened Poker2StandardOkDialog:: init");
    }

    protected applyProperties(): void {
        console.log("Opened Poker2StandardOkDialog:: applyProperties");
        this.standardDialog.btn_ok.label = this.standardDialogProperties.buttonLabel_ok;
        TextFieldHelper.changeTextFromatSizeByTextWidth(12, this.standardDialog.txt_title, this.standardDialogProperties.title);
        TextFieldHelper.changeTextFromatSizeByTextWidth(9, this.standardDialog.txt_copy, this.standardDialogProperties.copy, 7);
    }

    protected onClick(event: MouseEvent): void {
        super.onClick(event);
        switch (event.target) {
            case this.standardDialog.btn_close:
                console.log("Opened Poker2StandardOkDialog:: btn_close");
                this.hide();
                break;
            case this.standardDialog.btn_ok:
                console.log("Opened Poker2StandardOkDialog:: btn_ok");
                this.hide();
                if (this.standardDialogProperties.functionOk != null)
                    this.standardDialogProperties.functionOk(null);
                break;
        }
    }

    protected get standardDialogProperties(): BasicStandardOkDialogProperties {
        return this.properties as BasicStandardOkDialogProperties;
    }

    protected get standardDialog(): Library.PokerInterface.PokerStandardOk {
        return this.disp as Library.PokerInterface.PokerStandardOk;
    }

    public static __initialize_static_members() {
        Poker2StandardOkDialog.NAME = CommonDialogNames.StandardOkDialog_NAME;
    }
}
Poker2StandardOkDialog.__initialize_static_members();
